module.exports = __webpack_public_path__ + "img/1-2.5f0908d2.png";